<script>
import Vue from "vue";

import NsTopnavGivingBack from "./NsTopnavGivingBack.vue";
import NsTopnavLinkList from "./NsTopnavLinkList.vue";
import NsTopnavProductHighlight from "./NsTopnavProductHighlight.vue";
import NsTopnavProductLine from "./NsTopnavProductLine.vue";

export default {
  name: "NsDynamicHtml",
  components: {
    // Note: Components are dynamically loaded, ignore unused component errors, replace if alternative
    /* eslint-disable vue/no-unused-components */
    NsTopnavGivingBack,
    NsTopnavLinkList,
    NsTopnavProductHighlight,
    NsTopnavProductLine
  },
  props: {
    template: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      templateRender: null
    };
  },
  watch: {
    template: {
      immediate: true,
      handler() {
        const res = Vue.compile(this.template);

        this.templateRender = res.render;
        this.$options.staticRenderFns = [];

        // clean the cache of static elements
        // this is a cache with the results from the staticRenderFns
        this._staticTrees = [];

        // Fill it with the new staticRenderFns
        for (const index in res.staticRenderFns) {
          this.$options.staticRenderFns.push(res.staticRenderFns[index]);
        }
      }
    }
  },
  render() {
    if (!this.templateRender) {
      return null;
    } else {
      return this.templateRender();
    }
  }
};
</script>
